import React, { useEffect } from "react";
import "./MentalHealth.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import mentalImg from "../../Asset/Images/MentalHealth.png";

const MentalHealth = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  // Keys for the 8 mental health support cards
  const mhPoints = [
    "mh.point1",
    "mh.point2",
    "mh.point3",
    "mh.point4",
    "mh.point5",
    "mh.point6",
    "mh.point7",
    "mh.point8"
  ];

  return (
    <div className="mh_page">
      {/* HERO SECTION */}
      <section className="mh_hero">
        <div className="mh_card_container">
          <div className="mh_content" data-aos="fade-right">
            <span className="mh_service_tag">{t('mh.service_tag')}</span>
            <h1>
              {t('mh.title_start')} <span>{t('mh.title_end')}</span>
            </h1>
            <p>{t('mh.hero_desc')}</p>
          </div>

          <div className="mh_image" data-aos="fade-left">
            <img src={mentalImg} alt={t('mh.title_start') + " " + t('mh.title_end')} />
          </div>
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="mh_details">
        <h2 data-aos="fade-up">{t('mh.details_title')}</h2>
        <div className="mh_grid">
          {mhPoints.map((key, index) => (
            <div className="mh_card" key={index} data-aos="zoom-in">
              {t(key)}
            </div>
          ))}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="mh_cta" data-aos="fade-up">
        <h2>{t('mh.cta_title')}</h2>
        <p>{t('mh.cta_desc')}</p>
        <NavLink to="/Contactus">
          <button className="assisted_cta_btn">
            {t('common.contact_us')}
          </button>
        </NavLink>
      </section>
    </div>
  );
};

export default MentalHealth;